<!--
 * @Descripttion: 专区管理
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="zone-mgmt-list">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  useInputColumn,
  createDialog,
  BaseButton,
  BaseSelect
} from 'xrk-components';
import RelatedProject from '../components/related-project.vue';
import { formatter } from '@/utils';
import { zonesList, delZone } from '../data-source/apis';
import { RELATED_TYPE } from '../constants/index';

const router = useRouter();
const route = useRoute();
const xrkTableRef = ref();

const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useInputColumn({
      prop: 'title',
      label: '专区名称',
      config: {
        type: 'text',
        maxlength: 50
      }
    }),
    useSelectColumn({
      prop: 'hasProject',
      label: '关联项目状态',
      config: {
        options: RELATED_TYPE
      }
    })
  ],
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              v-resource={[['新建专区']]}
              type="primary2"
              onclick={async () => {
                let hasForm = ref(null);
                createDialog({
                  width: 350,
                  title: '新建专区',
                  showClose: true,
                  showFooter: false,
                  contentRender: done => {
                    return (
                      <>
                        <div style="padding:20px">
                          <div style="margin-bottom:10px">
                            专区内资讯是否关联表单
                          </div>
                          <BaseSelect
                            placeholder="请选择"
                            v-model={hasForm.value}
                            options={[
                              { label: '是', value: 1 },
                              { label: '否', value: 0 }
                            ]}
                          ></BaseSelect>
                          <div style="margin-top:20px;text-align:right">
                            <BaseButton
                              type="default"
                              onClick={() => {
                                done();
                              }}
                            >
                              取消
                            </BaseButton>
                            <BaseButton
                              disabled={hasForm.value === null}
                              onClick={() => {
                                done();
                                router.push({
                                  path: `/main/${route.meta.platFrom}/zone-mgmt/add`,
                                  query: {
                                    hasForm: hasForm.value
                                  }
                                });
                              }}
                            >
                              保存
                            </BaseButton>
                          </div>
                        </div>
                      </>
                    );
                  }
                });
              }}
            >
              新建专区
            </BaseButton>
          </>
        );
      }
    }
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px'
    }),
    useTableColumn({
      label: '编号ID',
      prop: 'zoneCode'
    }),
    useTableColumn({
      label: '专区名称',
      prop: 'title'
    }),
    useTableColumn({
      label: '专区内资讯是否关联表单',
      prop: 'hasForm',
      formatter({ cellValue }) {
        return RELATED_TYPE[cellValue]?.label;
      }
    }),
    useTableColumn({
      label: '资讯数量',
      prop: 'infoNum'
    }),
    useTableColumn({
      label: '关联项目状态',
      prop: 'hasProject',
      formatter({ cellValue }) {
        return RELATED_TYPE[cellValue]?.label;
      }
    }),
    useTableColumn({
      label: '关联项目数量',
      prop: 'projectNum',
      render({ row, cellValue }) {
        return (
          <div>
            <BaseButton
              type="text"
              disabled={cellValue === 0}
              onClick={() => {
                createDialog({
                  width: 1200,
                  title: '关联项目',
                  showClose: true,
                  confirmBtnConfig: {
                    show: false
                  },
                  cancelBtnConfig: {
                    show: true,
                    content: '关闭'
                  },
                  contentRender: () => (
                    <>
                      <RelatedProject
                        hasForm={+row.hasForm}
                        row={row}
                      ></RelatedProject>
                    </>
                  )
                });
              }}
            >
              {cellValue}
            </BaseButton>
          </div>
        );
      }
    }),
    useTableColumn({
      label: '更新时间',
      prop: 'updateAt',
      minWidth: 180,
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作',
      prop: 'handlerCol',
      fixed: 'right',
      width: 200,
      render: ({ row }) => {
        return (
          <div>
            <BaseButton
              v-resource={[['编辑']]}
              type="text"
              onClick={() => {
                router.push({
                  path: `/main/${route.meta.platFrom}/zone-mgmt/edit`,
                  query: {
                    id: row.id,
                    hasForm: +row.hasForm
                  }
                });
              }}
            >
              编辑
            </BaseButton>
            <BaseButton
              v-resource={[['删除']]}
              type="text"
              disabled={+row.hasProject === 1}
              onClick={() => {
                createDialog({
                  width: 350,
                  title: '提示',
                  showClose: true,
                  content: '是否确认删除？',
                  beforeConfirm: async done => {
                    await delZone({ id: row.id, hasForm: row.hasForm });
                    done();
                    onRefreshTabel();
                  }
                });
              }}
            >
              删除
            </BaseButton>
          </div>
        );
      }
    })
  ]
});

const getListAjax = async params => {
  return await zonesList({
    ...params,
    hasForm: +params.hasForm
  });
};
</script>
<style lang="scss"></style>
